import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { Token } from '../model/token';
import { Login } from '../model/login';


@Injectable()
export class KklRestService {

   // protected basePath = 'http://localhost:3200';
    //protected basePath =  'https://kkl-rest-app-cloud.azurewebsites.net';
    protected basePath = 'https://kk-api-management.azure-api.net/kkl';
    //protected basePath = 'https://kkl-api-app-docker.azurewebsites.net/';

    //protected debugParameter = '?XDEBUG_SESSION_START=PHPSTORM';
    protected debugParameter = '';


    public defaultHeaders = new HttpHeaders();

    constructor(private httpClient: HttpClient) {
    }

    /**
     * Invalidate user token
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public logout(token: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public logout(token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public logout(token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public logout(token: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('token', token);
        return this.httpClient.get<any>(`${this.basePath}/logout${this.debugParameter}`,
            {
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }



    /**
     * login user and create auth token
     *
     * @param body user authentification data in body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public login(body: Login, observe?: 'body', reportProgress?: boolean): Observable<Token>;
    public login(body: Login, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Token>>;
    public login(body: Login, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Token>>;
    public login(body: Login, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling loign.');
        }
        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Content-Type', 'application/json');
        return this.httpClient.post(
            `${this.basePath}/login${this.debugParameter}`,
            body,
             {
                 headers: headers
             }

        );
    }


    /**
     * login user and create auth token
     *
     * @param body user authentification data in body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public kkl(body: Object, token: string, observe?: 'body', reportProgress?: boolean): Observable<Token>;
    public kkl(body: Object, token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Token>>;
    public kkl(body: Object, token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Token>>;
    public kkl(body: Object, token: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling loign.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('token', token);

        return this.httpClient.post<Token>(`${this.basePath}/kkl${this.debugParameter}`,
            body,
            {
                withCredentials: true,
                headers: headers,
                observe: observe
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/kkl-rest-service.service.ts